import { useSearchParams } from "react-router-dom";
import ExerciseCategoryService from "../../../services/ExerciseCategoryService";
import { ExerciseCategory } from "../../../models";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Breadcrumbs from "../../../components/breadcrumbs";
import ExerciseCategoriesTable from "./ui/ExerciseCategoriesTable";
import ExerciseCategoriesTableSkeleton from "./skeletons/ExerciseCategoriesTableSkeleton";
import { CreateButton } from "./ui/buttons";

export default function ExerciseCategoriesPage() {
  const [searchParams] = useSearchParams();
  const api = new ExerciseCategoryService();
  const [items, setItems] = useState<ExerciseCategory[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [searchParams.get("reload")]);

  const fetchData = async () => {
    try {
      const data = await api.getExerciseCategories();
      setItems(data);
      toast.success("Exercise categories loaded successfully!");
    } catch (e) {
      console.log(e);
      toast.error("Failed to load exercise categories.");
    }
    setLoading(false);
  };

  return (
    <div className="w-full">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Exercise Categories", href: "/admin/exercise-categories" },
        ]}
      />

      <CreateButton />
      {loading ? (
        <ExerciseCategoriesTableSkeleton />
      ) : (
        <ExerciseCategoriesTable categories={items} />
      )}
    </div>
  );
}
